import { css } from 'styled-components';
import { TypographyColors } from '../../core/theme';

export const BaseFont = css`
  margin: 0;
  padding: 0;
  color: ${TypographyColors.mainText};
`;

export const Heading1 = css`
  ${BaseFont}
  font-size: 57px;
  font-weight: 700;
  line-height: 57px;
`;

export const Heading2 = css`
  ${BaseFont}
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
`;

export const Heading3 = css`
  ${BaseFont}
  font-size: 40px;
  font-weight: 700;
  line-height: 32px;
`;

export const Heading4 = css`
  ${BaseFont}
  font-size: 33px;
  font-weight: 700;
  line-height: 32px;
`;

export const Heading5 = css`
  ${BaseFont}
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
`;

export const Heading6 = css`
  ${BaseFont}
  font-size: 23px;
  font-weight: 700;
  line-height: 32px;
`;

export const BodyLarge = css`
  ${BaseFont}
  font-weight: 500;
  font-size: 19px;
  line-height: 28px;
`;

export const BodyRegular = css`
  ${BaseFont}
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;

export const BodySmall = css`
  ${BaseFont}
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
`;

export const BodyExtraSmall = css`
  ${BaseFont}
  font-weight: 300;
  font-size: 11px;
  line-height: 16px;
`;

export const BodyLargeBold = css`
  ${BaseFont}
  font-weight: 700;
  font-size: 19px;
  line-height: 28px;
`;
export const BodyRegularMedium = css`
  ${BaseFont}
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;
export const BodyLargeMedium = css`
  ${BaseFont}
  font-weight: 500;
  font-size: 19px;
  line-height: 28px;
`;
export const BodyRegularSemiBold = css`
  ${BaseFont}
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;
export const BodyExtraSmallMedium = css`
  ${BaseFont}
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
`;
export const BodySmallMedium = css`
  ${BaseFont}
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
`;
export const BodySmallSummary = css`
  ${BaseFont}
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
`;
export const BodyRegularBold = css`
  ${BaseFont}
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
